import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class VendorPlanFeatureService {
  constructor(private http: HttpClient) {}

  getFeatures(params: any = {}): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/vendor-plan-features`, { params });
  }

  getFeature(_id: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/vendor-plan-features/${_id}`);
  }

  getSubFeatures(featureId: string): Observable<any> {
    return this.http.get<any>(`${environment.apiUrl}/vendor-plan-features/${featureId}/sub-features`);
  }
}
